import React from 'react';

import Icon from '../Icon/Icon';

const PauseModeIcon = (props) => {
    return (
        <Icon width='48' height='48' fill='none' {...props}>
            <rect x='14' y='8' width='20' height='31' rx='10' stroke='#FFFDFB' strokeWidth='2' />
            <path
                d='M17 22v7a7 7 0 0 0 7 7v0a7 7 0 0 0 7-7v-7'
                stroke='#00D1D2'
                strokeWidth='2'
                strokeLinecap='round'
            />
        </Icon>
    );
};

export default PauseModeIcon;
